import React from "react";
import "../../App.css";

export default function SignUp() {
  return <h1 className="sign-up">SUBSCRIBE TO OUR NEWSLETTER</h1>;
}
